
import { Outlet,useLocation } from 'react-router-dom';
import { useState,useEffect } from 'react';

export default function UserDashboard(){

    return (
    <Outlet context={{
    }} />

    )
}
